import { useState } from "react";
import { useNotepadStore } from "../store/notepad";
import t from "../locales";

const dirClasses = {
  up: "tooltip__tip--up",
  down: "tooltip__tip--down",
  left: "tooltip__tip--left",
  right: "tooltip__tip--right",
};

export default function SaveInfoTooltip({ name, children, dir = "down" }) {
  const secrets = useNotepadStore((state) => state.secrets);
  const saved = secrets[name];
  const saveInfo = useNotepadStore((state) => state.saveInfo);
  const [showTooltip, setShowTooltip] = useState(false);

  const save = () => {
    saveInfo(name);
    setTimeout(() => setShowTooltip(false), 2000);
  };

  return (
    <span className="tooltip">
      <span className="tooltip__trigger" onClick={() => setShowTooltip(true)}>
        {children}
      </span>
      {showTooltip && (
        <div className={`tooltip__tip ${dirClasses[dir]}`}>
          {saved ? (
            t("tooltip_saved")
          ) : (
            <button className="tooltip__button" onClick={save}>
              {t("tooltip_save_in_notes")}
            </button>
          )}
        </div>
      )}
    </span>
  );
}
